import {t} from "../i18n/index.ts";
import {req} from '../api.ts';
import {h} from '../dom.ts';
import {ensurePlayer,readPlayer,sessionRecovery} from './client.ts';

export function playerPreferences(changed?:()=>void):HTMLElement {
  const root=h(`<details class="club-save"><summary>${t("settings.clubName")}</summary>
    <form><label class="field"><span>${t("settings.nameLabel")}</span><input name="username" minlength="3" maxlength="20" pattern="[A-Za-z0-9_-]+" required autocomplete="nickname" /></label>
    <p class="fine">${t("settings.nameHelp")}</p>
    <button class="btn" type="submit">${t("settings.saveName")}</button><button class="btn ghost" type="button" data-skip>${t("settings.skip")}</button></form><p class="msg" role="status" aria-live="polite"></p></details>`);
  const input=root.querySelector<HTMLInputElement>('input')!,message=root.querySelector<HTMLElement>('.msg')!;
  let edited=false;input.oninput=()=>{edited=true;};
  void readPlayer().then(player=>{if(player&&!edited)input.value=player.username;}).catch(()=>{});
  root.querySelector<HTMLButtonElement>('[data-skip]')!.onclick=()=>{(root as HTMLDetailsElement).open=false;};
  root.querySelector('form')!.onsubmit=event=> {
    event.preventDefault();root.querySelectorAll<HTMLButtonElement>('button').forEach(b=>b.disabled=true);
    void (async()=> {
      try{const player=await ensurePlayer();await req('POST','/api/play/profile',{actor_id:player.id,username:input.value.trim()});message.textContent=t("settings.nameSaved");changed?.();}
      catch(error){message.textContent=t("settings.nameFailed");sessionRecovery(root,error);}
      finally{root.querySelectorAll<HTMLButtonElement>('button').forEach(b=>b.disabled=false);}
    })();
  };
  return root;
}

export function signOutControl():HTMLElement {
  const root=h(`<details class="club-save"><summary>${t("settings.session")}</summary><p>${t("settings.signOutHelp")}</p><button class="btn ghost">${t("settings.signOutBrowser")}</button><p class="msg" role="status"></p></details>`);
  const button=root.querySelector('button')!;
  button.onclick=async()=> {
    button.disabled=true;
    try{await req('POST','/api/play/logout');location.reload();}
    catch(error){root.querySelector('.msg')!.textContent=t("settings.signOutFailed");button.disabled=false;sessionRecovery(root,error);}
  };
  return root;
}
